export default __webpack_public_path__ + "static/media/Note-Taker.71b379aa.png";